import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import Loading from 'components/shared-components/Loading';
import { APP_PREFIX_PATH } from 'configs/AppConfig'
import { NAV_PATH } from "configs/NavigationConfig";
import { isPartnerAdmin } from "utils/common";

export const AppViews = () => {
  const location = useLocation();

  // partner_admin only has access to the Revenue page — keep them there even
  // if they navigate directly to another admin URL.
  if (isPartnerAdmin() && location.pathname !== NAV_PATH.partners) {
    return <Redirect to={NAV_PATH.partners} />;
  }

  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <Route path={`${NAV_PATH.scholarships.template}`} exact component={lazy(() => import(`./scholarships/create/scholarship-wizard`))} />
        <Route path={`${NAV_PATH.scholarships.wizard}`} component={lazy(() => import(`./scholarships/create/scholarship-wizard`))} />
        <Route path={`${APP_PREFIX_PATH}/scholarshipdetail/:id`} exact component={lazy(() => import(`./scholarships/create/scholarship-wizard`))} />
        <Route path={`${NAV_PATH.dashboard}`} exact component={lazy(() => import(`./dashboards`))} />
        <Route path={`${NAV_PATH.users}`} exact component={lazy(() => import(`./users`))} />
        <Route path={`${NAV_PATH.loans}`} exact component={lazy(() => import(`./loans`))} />
        <Route path={`${NAV_PATH.partners}`} exact component={lazy(() => import(`./partners`))} />
        <Route path={`${NAV_PATH.navyLeads}`} exact component={lazy(() => import(`./navy-leads`))} />
        <Route path={`${NAV_PATH.thirdPartyLeads}`} exact component={lazy(() => import(`./navy-leads`))} />
        <Route path={`${NAV_PATH.collegeReconLeads}`} exact component={lazy(() => import(`./college-recon-leads`))} />
        <Route path={`${NAV_PATH.arcamaxLeads}`} exact component={lazy(() => import(`./arcamax-leads`))} />
        <Route path={`${NAV_PATH.sponsoredScholarshipLeads}`} exact component={lazy(() => import(`./sponsored-scholarship-leads`))} />
        <Route path={`${NAV_PATH.adminUsers}`} exact component={lazy(() => import(`./admin-users`))} />
        <Route path={`${NAV_PATH.adminAccounts}`} exact component={lazy(() => import(`./admin-accounts`))} />
        <Route path={`${NAV_PATH.business_users}`} exact component={lazy(() => import(`./business-users`))} />
        <Route path={`${NAV_PATH.active_users}`} exact component={lazy(() => import(`./active-users`))} />
        <Route path={`${NAV_PATH.cancel_order}`} exact component={lazy(() => import(`./cancel-order`))} />
        <Route path={`${NAV_PATH.orders}`} exact component={lazy(() => import(`./orders`))} />
        <Route path={`${NAV_PATH.userAnalytics}`} exact component={lazy(() => import(`./user-analytics`))} />
        <Route path={`${NAV_PATH.adminLogs}`} exact component={lazy(() => import(`./admin-logs`))} />
        <Route path={`${NAV_PATH.accountDeletionLogs}`} exact component={lazy(() => import(`./account-deletion-logs`))} />
        <Route path={`${NAV_PATH.scholarships.list}`} exact component={lazy(() => import(`./scholarships`))} />
        <Route
          exact
          path={`${NAV_PATH.scholarships.detail(`:id`)}`}
          component={lazy(() => import(`./scholarships/create/screens/Detail`))}
        />
        <Route
          exact
          path={`${NAV_PATH.scholarships.edit(`:id`)}`}
          component={lazy(() => import(`./scholarships/edit/scholarships-tab`))}
        />
        <Route
          exact
          path={`${NAV_PATH.scholarships.manage}`}
          component={lazy(() => import(`./scholarships/manage-scholarship`))}
        />

        {/* <Redirect from={`${APP_PREFIX_PATH}`} to={`${NAV_PATH.dashboard}`} /> */}
      </Switch>
    </Suspense>
  )
}

export default React.memo(AppViews);
